import { ThunkType } from "../../../../core/store/reducers";
import { getGuaranteesExcel } from "../api/getGuaranteesExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../guaranteesDataSlice";

export const downloadGuaranteesExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {

  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.guarantees;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getGuaranteesExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "Guarantees.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
